"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_onclickoutside_1 = require("react-onclickoutside");
var date_fns_1 = require("date-fns");
var TetherComponent_1 = require("../Internal/TetherComponent");
var calendar_1 = require("./subcomponents/calendar");
var date_input_1 = require("./subcomponents/date_input");
var date_utils_1 = require("./subcomponents/date_utils");
var date_1 = require("../../utils/date");
var outsideClickIgnoreClass = 'react-datepicker-ignore-onclickoutside';
var WrappedCalendar = react_onclickoutside_1.default(calendar_1.Calendar);
exports.datePickerInternalPropTypes = {
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.bool,
    calendarClassName: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    customInput: PropTypes.element,
    dateFormat: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.array.isRequired]),
    dateFormatCalendar: PropTypes.string,
    disabled: PropTypes.bool,
    dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
    endDate: PropTypes.object,
    excludeDates: PropTypes.array,
    filterDate: PropTypes.func,
    fixedHeight: PropTypes.bool,
    highlightDates: PropTypes.array,
    id: PropTypes.string,
    includeDates: PropTypes.array,
    inline: PropTypes.bool,
    isClearable: PropTypes.bool,
    locale: PropTypes.string,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    monthsShown: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onChangeRaw: PropTypes.func,
    onFocus: PropTypes.func,
    onMonthChange: PropTypes.func,
    openToDate: PropTypes.object,
    peekNextMonth: PropTypes.bool,
    placeholderText: PropTypes.string,
    popoverAttachment: PropTypes.string,
    popoverTargetAttachment: PropTypes.string,
    popoverTargetOffset: PropTypes.string,
    readOnly: PropTypes.bool,
    renderCalendarTo: PropTypes.any,
    required: PropTypes.bool,
    scrollableYearDropdown: PropTypes.bool,
    selected: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    selectsEnd: PropTypes.bool,
    selectsStart: PropTypes.bool,
    showMonthDropdown: PropTypes.bool,
    showWeekNumbers: PropTypes.bool,
    showYearDropdown: PropTypes.bool,
    forceShowMonthNavigation: PropTypes.bool,
    startDate: PropTypes.object,
    tabIndex: PropTypes.number,
    tetherConstraints: PropTypes.array,
    title: PropTypes.string,
    todayButton: PropTypes.string,
    withPortal: PropTypes.bool,
    theme: PropTypes.string
};
exports.datePickerInternalDefaultProps = {
    dateFormatCalendar: 'MMMM yyyy',
    onChange: function () {
        /* empty on purpose */
    },
    disabled: false,
    dropdownMode: 'scroll',
    onFocus: function () {
        /* empty on purpose */
    },
    onBlur: function () {
        /* empty on purpose */
    },
    onMonthChange: function () {
        /* empty on purpose */
    },
    popoverAttachment: 'top left',
    popoverTargetAttachment: 'bottom left',
    popoverTargetOffset: '10px 0',
    tetherConstraints: [
        {
            to: 'window',
            attachment: 'together'
        }
    ],
    monthsShown: 1,
    withPortal: false,
    locale: 'de-de',
    theme: 'ergodirekt'
};
/**
 * General datepicker component.
 */
var DatePickerInternal = /** @class */ (function (_super) {
    __extends(DatePickerInternal, _super);
    function DatePickerInternal(props) {
        var _this = _super.call(this, props) || this;
        _this.clearPreventFocusTimeout = function () {
            if (_this.preventFocusTimeout) {
                clearTimeout(_this.preventFocusTimeout);
            }
        };
        _this.setOpen = function (isOpen) {
            _this.setState({
                open: isOpen
            });
        };
        _this.handleFocus = function (event) {
            if (!_this.state.preventFocus) {
                _this.props.onFocus(event);
                _this.setOpen(true);
            }
        };
        _this.cancelFocusInput = function () {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = null;
        };
        _this.deferFocusInput = function () {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = window.setTimeout(function () { return _this.setFocus(); }, 1);
        };
        _this.handleBlur = function (event) {
            _this.handleCommit();
            if (_this.state.open) {
                _this.deferFocusInput();
            }
            else {
                _this.props.onBlur(event);
            }
        };
        _this.handleCalendarClickOutside = function (event) {
            _this.setOpen(false);
            if (_this.props.withPortal) {
                event.preventDefault();
            }
        };
        _this.handleSelect = function (date, event) {
            // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.setState({ preventFocus: true }, function () {
                _this.preventFocusTimeout = setTimeout(function () { return _this.setState({ preventFocus: false }); }, 50);
                return _this.preventFocusTimeout;
            });
            _this.setSelected(date, event);
            _this.setOpen(false);
        };
        _this.handleCommit = function () {
            if (_this.props.onCommit) {
                var currentValue = date_1.parse(_this.input.state.value) || _this.input.state.value;
                _this.props.onCommit(currentValue);
            }
        };
        _this.setSelected = function (date, event) {
            var changedDate = date;
            if (typeof changedDate === 'string') {
                _this.props.onChange(changedDate, event);
            }
            else {
                if (changedDate !== null && date_utils_1.isDayDisabled(changedDate, _this.props)) {
                    return;
                }
                if (!date_fns_1.isSameDay(typeof _this.props.selected === 'string' ? date_fns_1.parseISO(_this.props.selected) : _this.props.selected, changedDate)) {
                    if (changedDate !== null) {
                        if (_this.props.selected && _this.props.selected instanceof Date) {
                            changedDate = date_fns_1.setHours(changedDate, date_fns_1.getHours(_this.props.selected));
                            changedDate = date_fns_1.setMinutes(changedDate, date_fns_1.getMinutes(_this.props.selected));
                            changedDate = date_fns_1.setSeconds(changedDate, date_fns_1.getSeconds(_this.props.selected));
                        }
                        _this.setState({
                            preSelection: changedDate
                        });
                    }
                    _this.props.onChange(changedDate, event);
                }
            }
        };
        _this.onInputClick = function () {
            if (!_this.props.disabled) {
                _this.setOpen(true);
            }
        };
        _this.onInputKeyDown = function (event) {
            if (event.key === 'Enter') {
                _this.setOpen(false);
                _this.handleCommit();
            }
            else if (event.key === 'Escape' || event.key === 'Tab') {
                _this.setOpen(false);
            }
        };
        _this.onClearClick = function (event) {
            event.preventDefault();
            _this.props.onChange(null, event);
        };
        _this.renderCalendar = function () {
            if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
                return null;
            }
            // ensure only valid selection is passed to wrapped calendar
            var validSelection = _this.props.selected instanceof Date ? _this.props.selected : null;
            var validPreSelection = _this.state.preSelection instanceof Date ? _this.state.preSelection : new Date();
            return (React.createElement(WrappedCalendar, { ref: function (el) {
                    _this.calendar = el;
                }, locale: _this.props.locale, dateFormat: _this.props.dateFormatCalendar, dropdownMode: _this.props.dropdownMode, selected: validSelection, preSelection: validPreSelection, onSelect: _this.handleSelect, openToDate: _this.props.openToDate, minDate: _this.props.minDate, maxDate: _this.props.maxDate, selectsStart: _this.props.selectsStart, selectsEnd: _this.props.selectsEnd, startDate: _this.props.startDate, endDate: _this.props.endDate, excludeDates: _this.props.excludeDates, filterDate: _this.props.filterDate, onClickOutside: _this.handleCalendarClickOutside, highlightDates: _this.props.highlightDates, includeDates: _this.props.includeDates, inline: _this.props.inline, peekNextMonth: _this.props.peekNextMonth, showMonthDropdown: _this.props.showMonthDropdown, showWeekNumbers: _this.props.showWeekNumbers, showYearDropdown: _this.props.showYearDropdown, forceShowMonthNavigation: _this.props.forceShowMonthNavigation, scrollableYearDropdown: _this.props.scrollableYearDropdown, todayButton: _this.props.todayButton, outsideClickIgnoreClass: outsideClickIgnoreClass, fixedHeight: _this.props.fixedHeight, monthsShown: _this.props.monthsShown, onMonthChange: _this.props.onMonthChange, className: _this.props.calendarClassName }, _this.props.children));
        };
        _this.renderDateInput = function () {
            var _a;
            var className = classnames(_this.props.className, (_a = {},
                _a[outsideClickIgnoreClass] = _this.state.open,
                _a));
            return (React.createElement(date_input_1.default, { ref: function (el) {
                    _this.input = el;
                }, id: _this.props.id, "data-component-id": _this.props['data-component-id'], name: _this.props.name, autoFocus: _this.props.autoFocus, autoFormatDate: _this.props.autoFormatDate, date: _this.props.selected, locale: _this.props.locale, minDate: _this.props.minDate, maxDate: _this.props.maxDate, excludeDates: _this.props.excludeDates, includeDates: _this.props.includeDates, filterDate: _this.props.filterDate, dateFormat: _this.props.dateFormat, onFocus: _this.handleFocus, onBlur: _this.handleBlur, onClick: _this.onInputClick, onChangeRaw: _this.props.onChangeRaw, onKeyDown: _this.onInputKeyDown, onChangeDate: _this.setSelected, placeholder: _this.props.placeholderText, disabled: _this.props.disabled, autoComplete: _this.props.autoComplete, className: className, title: _this.props.title, readOnly: _this.props.readOnly, required: _this.props.required, tabIndex: _this.props.tabIndex, customInput: _this.props.customInput }));
        };
        _this.renderClearButton = function () {
            if (_this.props.isClearable && _this.props.selected != null) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("a", { className: "ee_react-datepicker__close-icon", href: "#", onClick: _this.onClearClick })));
            }
            else {
                return null;
            }
        };
        var _a = _this.props, openToDate = _a.openToDate, selected = _a.selected;
        var defaultPreSelection = openToDate || new Date();
        _this.state = {
            open: false,
            preventFocus: false,
            preSelection: selected || defaultPreSelection
        };
        _this.initialState = __assign({}, _this.state);
        return _this;
    }
    DatePickerInternal.prototype.componentWillUnmount = function () {
        this.clearPreventFocusTimeout();
    };
    DatePickerInternal.prototype.setFocus = function () {
        this.input.focus();
    };
    DatePickerInternal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.selected &&
            date_fns_1.isValid(typeof this.props.selected === 'string' ? new Date(this.props.selected) : this.props.selected) &&
            !date_fns_1.isSameDay(typeof this.props.selected === 'string' ? date_fns_1.parseISO(this.props.selected) : this.props.selected, typeof prevProps.selected === 'string' ? date_fns_1.parseISO(prevProps.selected) : prevProps.selected) &&
            !date_fns_1.isSameDay(typeof this.state.preSelection === 'string' ? date_fns_1.parseISO(this.state.preSelection) : this.state.preSelection, typeof this.props.selected === 'string' ? date_fns_1.parseISO(this.props.selected) : this.props.selected)) {
            this.setState({
                preSelection: this.props.selected
            });
        }
    };
    DatePickerInternal.prototype.render = function () {
        var calendar = this.renderCalendar();
        if (this.props.inline && !this.props.withPortal) {
            return calendar;
        }
        if (this.props.withPortal) {
            return (React.createElement("div", null,
                !this.props.inline ? (React.createElement("div", { className: "ee_react-datepicker__input-container" },
                    this.renderDateInput(),
                    this.renderClearButton())) : null,
                this.state.open || this.props.inline ? React.createElement("div", { className: "ee_react-datepicker__portal" }, calendar) : null));
        }
        return (React.createElement(TetherComponent_1.TetherComponent
        // TODO: Is type correct here? Typecast should not be necessary.
        , { 
            // TODO: Is type correct here? Typecast should not be necessary.
            classes: {
                element: 'ee_react-datepicker__tether-element',
                'element-attached': 'ee_react-datepicker__tether-element-attached'
            }, attachment: this.props.popoverAttachment, targetAttachment: this.props.popoverTargetAttachment, targetOffset: this.props.popoverTargetOffset, constraints: this.props.tetherConstraints, theme: this.props.theme },
            React.createElement("div", { className: "ee_react-datepicker__input-container" },
                this.renderDateInput(),
                this.renderClearButton()),
            calendar));
    };
    DatePickerInternal.propTypes = exports.datePickerInternalPropTypes;
    DatePickerInternal.defaultProps = exports.datePickerInternalDefaultProps;
    return DatePickerInternal;
}(React.Component));
exports.DatePickerInternal = DatePickerInternal;
exports.default = DatePickerInternal;
//# sourceMappingURL=DatePickerInternal.js.map